import customAxios from "./axios";
import CONFIG from "../../config";

export const localization = (payload) => {
  return customAxios
    .get(CONFIG.apiURL + `/Localization/Get?language=${payload}`)
    .then((res) => {
      let response = res["data"];
      return response;
    });
};

export const localizationCreate = (payload) => {
  return customAxios
    .post(CONFIG.apiURL + `/Localization/Create`, payload)
    .then((res) => {
      return res;
    });
};
